export default {
  formId: 'createEmployeForm', //'checkoutForm',
  formField: {
    // DATOS BASICOS
    document_type: {
      name: 'document_type',
      label: 'Tipo de documento',
      requiredErrorMsg: 'Tipo de documento es requerido.',
    },
    document_number: {
      name: 'document_number',
      label: 'Numero de documento*',
      requiredErrorMsg: 'Numero de documento es requerido.',
      typeDataMsg: 'El campo es numerico.',
    },
    file_img_upload: {
      name: 'file_img_upload',
      label: 'Subir archivo*',
      requiredErrorMsg: 'Subir archivo es requerido.',
    },
    expedition_place: {
      name: 'expedition_place',
      label: 'Lugar de expedicion*',
      requiredErrorMsg: 'Lugar de expedicion es requerido.',
    },
    name: {
      name: 'name',
      label: 'Nombre*',
      requiredErrorMsg: 'El nombre  es requerido.',
    },
    last_name: {
      name: 'last_name',
      label: 'Apellidos*',
      requiredErrorMsg: 'Los apellidos son requeridos.',
    },
    date_of_birth: {
      name: 'date_of_birth',
      label: 'Fecha de Nacimiento',
      requiredErrorMsg: 'Fecha de Nacimiento es requerida.',
    },
    gender: {
      name: 'gender',
      label: 'Genero',
      requiredErrorMsg: 'Genero es requerido.',
    },
    civil_status: {
      name: 'civil_status',
      label: 'Estado civil',
      requiredErrorMsg: 'Estado civil es requerido.',
    },
    landline: {
      name: 'landline',
      label: 'Telefono fijo',
      requiredErrorMsg: 'Telefono fijo es requerido.',
    },
    cell_phone: {
      name: 'cell_phone',
      label: 'Celular',
      requiredErrorMsg: 'Celular es requerido.',
    },
    corporate_cell_phone: {
      name: 'corporate_cell_phone',
      label: 'Número corporativo',
      requiredErrorMsg: 'Número corporativo es requerido.',
    },
    whatsapp: {
      name: 'whatsapp',
      label: 'Este numero usa whatsapp?',
      requiredErrorMsg: 'El whatsapp es obligatorio.',
    },
    rh: {
      name: 'rh',
      label: 'Tipo de sangre',
      requiredErrorMsg: 'Tipo de sangre es requerido.',
    },
    dominance: {
      name: 'dominance',
      label: 'Dominacion',
      requiredErrorMsg: 'Dominacion es requerido.',
    },
    allergies: {
      name: 'allergies',
      label: 'alergias',
      requiredErrorMsg: 'alergias es requerido.',
    },
    cedula: {
      name: 'cedula',
      label: 'Cedula',
      requiredErrorMsg: 'Cedula es requerido.',
    },
    address: {
      name: 'address',
      label: 'Direccion Empleado*',
      requiredErrorMsg: 'La direccion es requerida.',
    },
    email: {
      name: 'email',
      label: 'Email*',
      requiredErrorMsg: 'El email es requerido.',
    },
    housing_type: {
      name: 'housing_type',
      label: 'Tipo vivienda*',
      requiredErrorMsg: 'El tipo vivienda es requerida.',
    },
    neighborhood: {
      name: 'neighborhood',
      label: 'Barrio*',
      requiredErrorMsg: 'El barrio es requerida.',
    },
    stratum: {
      name: 'stratum',
      label: 'Estrato*',
      requiredErrorMsg: 'El estrato es requerida.',
    },
    cost_center: {
      name: 'cost_center',
      label: 'Centro de costos*',
      requiredErrorMsg: 'El centro de costos es requerida.',
    },
    compani: {
      name: 'compani',
      label: 'Compañia*',
      requiredErrorMsg: 'El compañia es requerida.',
    },
    work_headquarters: {
      name: 'work_headquarters',
      label: 'Sucursal*',
      requiredErrorMsg: 'La Sucursal es requerida.',
    },
    cargo: {
      name: 'cargo',
      label: 'Cargo*',
      requiredErrorMsg: 'El cargo es requerida.',
    },
    cv: {
      name: 'cv',
      label: 'Hoja de vida*',
      requiredErrorMsg: 'La hoja de vida es requerida.',
    },
    scholarship: {
      name: 'scholarship',
      label: 'Escolaridad*',
      requiredErrorMsg: 'La escolaridad es requerida.',
    },
    institution: {
      name: 'institution',
      label: 'Institucion*',
      requiredErrorMsg: 'La institucion es requerida.',
    },
    degree: {
      name: 'degree',
      label: 'Titulo*',
      requiredErrorMsg: 'La titulo es requerida.',
    },
    // DOCUMENTOS
    cedula_name_saved_name: {
      name: 'cedula_name_saved_name',
      label: 'Cedula',
      requiredErrorMsg: 'Cedula es requerido.',
    },
    cv_name_saved_name: {
      name: 'cv_name_saved_name',
      label: 'Hoja de vida',
      requiredErrorMsg: 'Hoja de vida es requerido.',
    },

    // LABORAL
    type_contract: {
      name: 'type_contract',
      label: 'Tipo de contrato',
      requiredErrorMsg: 'Tipo de contrato es requerido.',
    },
    salary_base: {
      name: 'salary_base',
      label: 'Salario base',
      requiredErrorMsg: 'Salario base es requerido.',
      typeDataMsg: 'El campo es numerico.',
    },
    transport_subsidy: {
      name: 'transport_subsidy',
      label: 'Subsidio transporte',
      requiredErrorMsg: 'Subsidio transporte es requerido.',
    },
    payment_method: {
      name: 'payment_method',
      label: 'Metodo de pago',
      requiredErrorMsg: 'Metodo de pago es requerido.',
    },
    frecuency_payment: {
      name: 'frecuency_payment',
      label: 'Frecuencia de pago',
      requiredErrorMsg: 'Frecuencia de pago es requerido.',
    },
    associated_bank: {
      name: 'associated_bank',
      label: 'Banco',
      requiredErrorMsg: 'Banco es requerido.',
    },
    account_number: {
      name: 'account_number',
      label: 'Numero de cuenta',
      requiredErrorMsg: 'Numero de cuenta es requerido.',
    },
    certificate_bank: {
      name: 'certificate_bank',
      label: 'Certificado bancario',
      requiredErrorMsg: 'Certificado bancario es requerido.',
    },
    vacation_acumulate: {
      name: 'vacation_acumulate',
      label: 'Vacaciones acumuladas',
      requiredErrorMsg: 'Vacaciones acumuladas es requerida.',
      typeDataMsg: 'El campo es numerico.',
    },
    bonification_aditional: {
      name: 'bonification_aditional',
      label: 'Bonificacion adicional',
      requiredErrorMsg: 'Bonificacion adicional es requerida.',
      typeDataMsg: 'El campo es numerico.',
    },
    date_start_contract: {
      name: 'date_start_contract',
      label: 'Fecha de contratacion',
      requiredErrorMsg: 'Fecha de contratacion es requerida.',
    },
    lunes: {
      name: 'lunes',
      label: 'lunes',
      requiredErrorMsg: 'lunes es requerido.',
    },
    martes: {
      name: 'martes',
      label: 'martes',
      requiredErrorMsg: 'martes es requerido.',
    },
    miercoles: {
      name: 'miercoles',
      label: 'miercoles',
      requiredErrorMsg: 'miercoles es requerido.',
    },
    jueves: {
      name: 'jueves',
      label: 'jueves',
      requiredErrorMsg: 'jueves es requerido.',
    },
    viernes: {
      name: 'viernes',
      label: 'viernes',
      requiredErrorMsg: 'viernes es requerido.',
    },
    sabado: {
      name: 'sabado',
      label: 'sabado',
      requiredErrorMsg: 'sabado es requerido.',
    },
    domingo: {
      name: 'domingo',
      label: 'domingo',
      requiredErrorMsg: 'domingo es requerido.',
    },
    festivo: {
      name: 'festivo',
      label: 'festivo',
      requiredErrorMsg: 'festivo es requerido.',
    },
    dayrest: {
      name: 'dayrest',
      label: 'dayrest',
      requiredErrorMsg: 'Debes selecionar al menos un dia de descanso*',
    },
    // LABORAL
    certificate_banck_name_saved_name: {
      name: 'certificate_banck_name_saved_name',
      label: 'Certificado bancario',
      requiredErrorMsg: 'Certificado bancario es requerido.',
    },
    // FAMILIA
    numOfBeneficiary: {
      name: 'numOfBeneficiary',
      label: 'Numero de beneficiarios',
      requiredErrorMsg: 'Numero de beneficiarios es requerido.',
    },
    // family: {
    //   name: 'family',
    //   label: 'Familia',
    //   requiredErrorMsg: 'Familia es requerido.'
    // },
    // SEGURIDAD SOCIAL
    eps: {
      name: 'eps',
      label: 'eps',
      requiredErrorMsg: 'Eps es requerido.',
    },
    // CAJA DE COMPENSACION
    familyCompensation: {
      name: 'familyCompensation',
      label: 'caja de compensacion',
      requiredErrorMsg: 'Caja de compensacion es requerido.',
    },
    fileCajaCompensacion: {
      name: 'fileCajaCompensacion',
      label: 'caja de compensacion',
      requiredErrorMsg: 'Caja de compensacion es requerido.',
    },
    caja_compensacion_name_saved: {
      name: 'caja_compensacion_name_saved',
      label: 'Caja compensacion',
      requiredErrorMsg: 'Caja compensacion es requerido.',
    },
    // CESANTIAS
    cesantias: {
      name: 'cesantias',
      label: 'Cesantias',
      requiredErrorMsg: 'Cesantias es requerido.',
    },
    fileCesantias: {
      name: 'fileCesantias',
      label: 'Cesantias',
      requiredErrorMsg: 'Cesantias es requerido.',
    },
    cesantias_name_saved: {
      name: 'cesantias_name_saved',
      label: 'Cesantias',
      requiredErrorMsg: 'Cesantias es requerido.',
    },
    // PENSION
    pension: {
      name: 'pension',
      label: 'Pension',
      requiredErrorMsg: 'Pension es requerido.',
    },
    // ARL
    fileArl: {
      name: 'fileArl',
      label: 'Arl',
      requiredErrorMsg: 'Arl es requerido.',
    },
    arl_name_saved: {
      name: 'arl_name_saved',
      label: 'Arl',
      requiredErrorMsg: 'Arl es requerido.',
    },
    // DOTACION
    // items_uno: {
    //   name: 'items',
    //   label: 'Items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // talla_uno: {
    //   name: 'talla',
    //   label: 'Talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // cantidad_uno: {
    //   name: 'cantidad',
    //   label: 'Cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // color_uno: {
    //   name: 'color',
    //   label: 'Color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // item_descripcion_uno: {
    //   name: 'item_descripcion',
    //   label: 'Descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // items2: {
    //   name: 'items',
    //   label: 'Items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // talla2: {
    //   name: 'talla',
    //   label: 'Talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // cantidad2: {
    //   name: 'cantidad',
    //   label: 'Cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // color2: {
    //   name: 'color',
    //   label: 'Color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // item_descripcion2: {
    //   name: 'item_descripcion',
    //   label: 'Descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // items3: {
    //   name: 'items',
    //   label: 'Items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // talla3: {
    //   name: 'talla',
    //   label: 'Talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // cantidad3: {
    //   name: 'cantidad',
    //   label: 'Cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // color3: {
    //   name: 'color',
    //   label: 'Color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // item_descripcion3: {
    //   name: 'item_descripcion',
    //   label: 'Descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // items4: {
    //   name: 'items',
    //   label: 'Items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // talla4: {
    //   name: 'talla',
    //   label: 'Talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // cantidad4: {
    //   name: 'cantidad',
    //   label: 'Cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // color4: {
    //   name: 'color',
    //   label: 'Color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // item_descripcion4: {
    //   name: 'item_descripcion',
    //   label: 'Descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // items5: {
    //   name: 'items',
    //   label: 'Items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // talla5: {
    //   name: 'talla',
    //   label: 'Talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // cantidad5: {
    //   name: 'cantidad',
    //   label: 'Cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // color5: {
    //   name: 'color',
    //   label: 'Color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // item_descripcion5: {
    //   name: 'item_descripcion',
    //   label: 'Descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // PRUEBAS DE INGRESO / VISITA DOMICILIARIA
    vista_domiciliaria: {
      name: 'vista_domiciliaria',
      label: 'Visita domiciliaria',
      requiredErrorMsg: 'Visita domiciliaria es requerido.',
    },
    fileVisitaDomiciliaria: {
      name: 'fileVisitaDomiciliaria',
      label: 'Visita domiciliaria',
      requiredErrorMsg: 'Visita domiciliaria es requerido.',
    },
    visita_domiciliaria_name_saved: {
      name: 'visita_domiciliaria_name_saved',
      label: 'Visita domiciliaria',
      requiredErrorMsg: 'Visita domiciliaria es requerido.',
    },
    // PRUEBA PSICOTECNICA
    prueba_psicotecnica: {
      name: 'prueba_psicotecnica',
      label: 'Pruebas psicotecnicas',
      requiredErrorMsg: 'Pruebas psicotecnicas es requerido.',
    },
    filePsicotecnica: {
      name: 'filePsicotecnica',
      label: 'Pruebas psicotecnicas',
      requiredErrorMsg: 'Pruebas psicotecnicas es requerido.',
    },
    psicotecnica_name_saved: {
      name: 'psicotecnica_name_saved',
      label: 'Pruebas psicotecnicas',
      requiredErrorMsg: 'Pruebas psicotecnicas es requerido.',
    },
    // MANIPULACION ALIMENTOS
    manipulacion_alimentos: {
      name: 'manipulacion_alimentos',
      label: 'Manipulacion alimentos',
      requiredErrorMsg: 'Manipulacion alimentos es requerido.',
    },
    fileManipulacionAlimentos: {
      name: 'fileManipulacionAlimentos',
      label: 'Manipulacion alimentos',
      requiredErrorMsg: 'Manipulacion alimentos es requerido.',
    },
    manipulacion_alimentos_name_saved: {
      name: 'manipulacion_alimentos_name_saved',
      label: 'Manipulacion alimentos',
      requiredErrorMsg: 'Manipulacion alimentos es requerido.',
    },
    // TRABAJO EN ALTURAS
    trabajo_alturas: {
      name: 'trabajo_alturas',
      label: 'Trabajo en alturas',
      requiredErrorMsg: 'Trabajo en alturas es requerido.',
    },
    fileTrabajoAlturas: {
      name: 'fileTrabajoAlturas',
      label: 'Trabajo en alturas',
      requiredErrorMsg: 'Trabajo en alturas es requerido.',
    },
    trabajo_altura_name_saved: {
      name: 'trabajo_altura_name_saved',
      label: 'Trabajo en alturas',
      requiredErrorMsg: 'Trabajo en alturas es requerido.',
    },
    // EXAMEN MEDICO
    examen_medico: {
      name: 'examen_medico',
      label: 'Examen medico',
      requiredErrorMsg: 'Examen medico es requerido.',
    },
    fileExamenMedico: {
      name: 'fileExamenMedico',
      label: 'Examen medico',
      requiredErrorMsg: 'Examen medico es requerido.',
    },
    examen_medico_name_saved: {
      name: 'examen_medico_name_saved',
      label: 'Examen medico',
      requiredErrorMsg: 'Examen medico es requerido.',
    },
    // CONTRATO
    contrato: {
      name: 'contrato',
      label: 'contrato',
      requiredErrorMsg: 'contrato es requerido.',
    },
    // CERTIFICADO ESTUDIOS
    certificado_estudios: {
      name: 'certificado_estudios',
      label: 'Certificado estudios',
      requiredErrorMsg: 'Certificado estudios es requerido.',
    },
    fileCertificadoEstudios: {
      name: 'fileCertificadoEstudios',
      label: 'Certificado estudios',
      requiredErrorMsg: 'Certificado estudios es requerido.',
    },
    certificado_estudios_name_saved: {
      name: 'certificado_estudios_name_saved',
      label: 'Certificado estudios',
      requiredErrorMsg: 'Certificado estudios es requerido.',
    },
    // CERTIFICADO LABORAL
    certificado_laboral: {
      name: 'certificado_laboral',
      label: 'Certificado laboral',
      requiredErrorMsg: 'Certificado laboral es requerido.',
    },
    fileCertificadoLaboral: {
      name: 'fileCertificadoLaboral',
      label: 'Certificado laboral',
      requiredErrorMsg: 'Certificado laboral es requerido.',
    },
    certificado_laboral_name_saved: {
      name: 'certificado_laboral_name_saved',
      label: 'Certificado laboral',
      requiredErrorMsg: 'Certificado laboral es requerido.',
    },
    // VERIFICACION ADRES
    verificacion_adres: {
      name: 'verificacion_adres',
      label: 'Verificacion adres',
      requiredErrorMsg: 'Verificacion adres es requerido.',
    },
    fileVerificacionAdres: {
      name: 'fileVerificacionAdres',
      label: 'Verificacion adres',
      requiredErrorMsg: 'Verificacion adres es requerido.',
    },
    verificacion_adres_name_saved: {
      name: 'verificacion_adres_name_saved',
      label: 'Verificacion adres',
      requiredErrorMsg: 'Verificacion adres es requerido.',
    },
    // ANTECEDENTES
    antecedentes: {
      name: 'antecedentes',
      label: 'Antecedentes',
      requiredErrorMsg: 'Antecedentes es requerido.',
    },
    fileAntecedentes: {
      name: 'fileAntecedentes',
      label: 'Antecedentes',
      requiredErrorMsg: 'Antecedentes es requerido.',
    },
    antecedentes_name_saved: {
      name: 'antecedentes_name_saved',
      label: 'Antecedentes',
      requiredErrorMsg: 'Antecedentes es requerido.',
    },
    // ENTREVISTA
    entrevista: {
      name: 'entrevista',
      label: 'Entrevista',
      requiredErrorMsg: 'Entrevista es requerido.',
    },
    fileEntrevista: {
      name: 'fileEntrevista',
      label: 'Entrevista',
      requiredErrorMsg: 'Entrevista es requerido.',
    },
    entrevista_name_saved: {
      name: 'entrevista_name_saved',
      label: 'Entrevista',
      requiredErrorMsg: 'Entrevista es requerido.',
    },
    // ENTREVISTA SOCIODEMOGRAFICA
    sociodemografica: {
      name: 'sociodemografica',
      label: 'Entrevista sociodemografica',
      requiredErrorMsg: 'Entrevista sociodemografica es requerido.',
    },
    fileSociodemografica: {
      name: 'fileSociodemografica',
      label: 'Entrevista sociodemografica',
      requiredErrorMsg: 'Entrevista sociodemografica es requerido.',
    },
    sociodemografica_name_saved: {
      name: 'sociodemografica_name_saved',
      label: 'Entrevista sociodemografica',
      requiredErrorMsg: 'Entrevista sociodemografica es requerido.',
    },
    // ENCUESTA DME
    encuesta_dme: {
      name: 'encuesta_dme',
      label: 'Encuesta dme',
      requiredErrorMsg: 'Encuesta dme es requerido.',
    },
    fileEncuestaDme: {
      name: 'fileEncuestaDme',
      label: 'Encuesta dme',
      requiredErrorMsg: 'Encuesta dme es requerido.',
    },
    encuesta_dme_name_saved: {
      name: 'encuesta_dme_name_saved',
      label: 'Encuesta dme',
      requiredErrorMsg: 'Encuesta dme es requerido.',
    },
    // COMPROMISO SST
    compromiso_sst: {
      name: 'compromiso_sst',
      label: 'Compromiso sst',
      requiredErrorMsg: 'Compromiso sst es requerido.',
    },
    fileCompromisoSst: {
      name: 'fileCompromisoSst',
      label: 'Compromiso sst',
      requiredErrorMsg: 'Compromiso sst es requerido.',
    },
    compromiso_sst_name_saved: {
      name: 'compromiso_sst_name_saved',
      label: 'Compromiso sst',
      requiredErrorMsg: 'Compromiso sst es requerido.',
    },
  },
};
